import React, { useEffect, useState } from 'react';
import { AiFillDelete, AiFillEdit, AiOutlineRedo } from 'react-icons/ai';
import { HiDocumentDuplicate } from 'react-icons/all';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { confirmeOnClick } from '../../../ressources/functionJS/confirmeOnClick';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import * as actions from '../../../services/actions';
import Bouton from '../../UI/Bouton/Bouton';
import AffichageGraphe from '../AffichageGraphe/AffichageGraphe';
import FormulaireGraphe from './FormulaireGraphe/FormulaireGraphe';
import styles from './ProfilGraphe.module.scss';

const ProfilGraphe = ({ infoGraphe, reqSupprimer, reqCreerGraphe }) => {
  const [configurationGraphe, setConfigurationGraphe] = useState({
    graph_id: null,
  });
  const [afficherModifier, setAfficherModifier] = useState(false);

  const dispatch = useDispatch();
  const listeConfigurationsGraphes = useSelector(
    (state) => state.graphe.liste_configurations_graphes
  );

  const afficherModifierProfil = () => {
    setAfficherModifier(true);
  };

  useEffect(() => {
    if (
      infoGraphe.graph_id &&
      (listeConfigurationsGraphes[infoGraphe.graph_id] === undefined ||
        configurationGraphe.graph_id !== infoGraphe.graph_id)
    ) {
      dispatch(actions.reqRecupererGraphe(infoGraphe.graph_id));
      setConfigurationGraphe({
        ...listeConfigurationsGraphes[parseInt(infoGraphe.graph_id)],
      });
      setAfficherModifier(false);
    }
  }, [infoGraphe.graph_id]); // Changement: dépendance uniquement sur graph_id

  const formulaireModifier =
    listeConfigurationsGraphes[infoGraphe.graph_id] !== undefined ? (
      <FormulaireGraphe
        annuler={() => setAfficherModifier(false)}
        preconfigurerGraphe={listeConfigurationsGraphes[infoGraphe.graph_id]}
      />
    ) : null;

  const profil = (
    <>
      <div className={[s.row, styles.ConteneurInfo].join(' ')}>
        {listeConfigurationsGraphes[parseInt(infoGraphe.graph_id)] !==
          undefined &&
        listeConfigurationsGraphes[parseInt(infoGraphe.graph_id)].graph_id ===
          parseInt(infoGraphe.graph_id) ? (
          <div className={[s.col_12, s.text_left].join(' ')}>
            <FormulaireGraphe
              affichageProfil={true}
              annuler={() => setAfficherModifier(false)}
              preconfigurerGraphe={
                listeConfigurationsGraphes[infoGraphe.graph_id]
              }
            />
          </div>
        ) : null}

        <div className={[s.row, styles.bts].join(' ')}>
          <div className={styles.sas}>
            <AffichageGraphe graph_id={infoGraphe.graph_id} />
          </div>
          <div className={styles.sas}>
            <AttenteRequete request_type={requestType.recuperer_un_graphe}>
              <AccesRestreins numPrivilege={privilege.modifier_des_projets}>
                {listeConfigurationsGraphes[infoGraphe.graph_id] ? (
                  <Bouton cliquer={afficherModifierProfil}>
                    <AiFillEdit />
                    {checkMot('modifier')}
                  </Bouton>
                ) : (
                  <Bouton
                    cliquer={() =>
                      dispatch(actions.reqRecupererGraphe(infoGraphe.graph_id))
                    }
                  >
                    <AiOutlineRedo />
                    {checkMot('refresh')}
                    {infoGraphe.graph_id}
                  </Bouton>
                )}
              </AccesRestreins>
            </AttenteRequete>
          </div>
          <div className={styles.sas}>
            <AccesRestreins numPrivilege={privilege.modifier_des_projets}>
              <AttenteRequete request_type={requestType.creer_un_graphe}>
                <Bouton
                  cliquer={() =>
                    confirmeOnClick(
                      checkMot('voulez_vous_vraiment_dupliquer_ce_graphe'),
                      () =>
                        reqCreerGraphe({
                          ...listeConfigurationsGraphes[infoGraphe.graph_id],
                          graph_name:
                            listeConfigurationsGraphes[infoGraphe.graph_id]
                              .graph_name + '_dupliquer',
                        })
                    )
                  }
                >
                  <HiDocumentDuplicate />
                  {checkMot('dupliquer')}
                </Bouton>
              </AttenteRequete>
            </AccesRestreins>
          </div>
          <div className={styles.sas}>
            <AccesRestreins numPrivilege={privilege.supprimer_des_graphes}>
              <AttenteRequete request_type={requestType.supprimer_un_graphe}>
                <Bouton
                  cliquer={() =>
                    confirmeOnClick(
                      checkMot('voulez_vous_vraiment_supprimer_ce_graphe'),
                      () => reqSupprimer(infoGraphe.graph_id)
                    )
                  }
                >
                  <AiFillDelete />
                  {checkMot('supprimer')}
                </Bouton>
              </AttenteRequete>
            </AccesRestreins>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.card_header, styles.hedes].join(' ')}>
        <BsFillInfoCircleFill size={14} />
        {checkMot('graphe_id')} : {infoGraphe.graph_id}
      </div>
      <div className={s.container}>
        {afficherModifier ? formulaireModifier : profil}
      </div>
    </div>
  );
};

export default ProfilGraphe;
